// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/buy/payment-method/payment-method.less
// module id = 496
// module chunks = 0